import api from './api'

export const mediaService = {
  // GET /media?page&limit&folder
  listAssets: async (params = {}) => {
    const { data } = await api.get('/media', { params })
    return { assets: data.data, meta: data.meta }
  },

  // POST /media  — multipart/form-data, field: "image"
  uploadAsset: async (file, folder) => {
    const form = new FormData()
    form.append('image', file)
    if (folder) form.append('folder', folder)
    const { data } = await api.post('/media', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return data.data
  },

  // DELETE /media/:id
  deleteAsset: async (id) => {
    await api.delete(`/media/${id}`)
  },
}
